<template>
  <section>
  <div
    @click="hideMainMenu"
    :class="`menu-hider ${$store.state.app.mainMenuShow ? 'menu-active' : ''}`"
  ></div>
  <div
    id="menu-main"
    data-menu-active="nav-home"
    :class="`menu menu-box-left menu-gradient ${
      $store.state.app.mainMenuShow ? 'menu-active' : ''
    }`"
    data-menu-width="260"
    data-menu-effect="menu-parallax"
    style="display: block; width: 260px"
  >
    <div class="menu-wrap">
      <div class="text-center">
        <!-- <a href="#"
            ><img
              src="./nuur huudas/nuurhuudas_styles/1.png"
              class="sidebar-logo"
              width="85"
          /></a> -->
        <h1 class="text-uppercase color-white mt-3">UBTZ Youth</h1>
      </div>
      <!-- <span class="menu-divider">Хаашаа явах вэ?</span> -->
      <div class="menu-items">
        <template v-for="page in getMenuList(0)">
          <a @click="loadPage(page)">
            <i :class="`${page.f1}`" style="color: #5a6087"></i>
            <span>{{ getLangText(page) }}</span>
            <strong
              @click.stop="setActivePage(page.id)"
              class="badge"
              v-show="getMenuList(page.id).length > 0"
              >{{ getMenuList(page.id).length }}</strong
            >
            <i
              v-show="getMenuList(page.id).length == 0"
              class="fa fa-angle-right"
            ></i>
          </a>
          <div
            :class="`submenu`"
            :style="`${activeMenuId == page.id ? 'height: auto' : ''}`"
          >
            <a @click="loadPage(page)" v-for="page in getMenuList(page.id)">
              <!-- {{page.organizationTaskId}} {{page.locTypeId}} -->
              {{ getLangText(page) }}
              <i class="fa fa-angle-right"></i
            ></a>
          </div>
        </template>
      </div>

      <!-- <span class="menu-divider mt-4">Get in Touch</span>
      <div class="divider bg-white opacity-10 mt-4"></div>
      <p class="font-11 color-white opacity-30 text-center">
        Copyright <span class="copyright-year">2022</span> Enabled. All rights
        reserved.
      </p> -->
    </div>
  </div>
</section>
</template>
<script>
import { mapActions } from "vuex";
var _ = require("lodash");
export default {
  data() {
    return {
      activeMenuId: 0,
    };
  },
  methods: {
    getLangText(task) {
      let lng = this.$i18n.locale;
      if (lng == "en") {
        return task.st5 ?? task.task;
      } else if (lng == "ru") {
        return task.st4 ?? task.task;
      } else if (lng == "cn") {
        return task.st6 ?? task.task;
      } else {
        return task.task;
      }
    },
    ...mapActions(["handleMainMenu", "handleDetailModal"]),
    hideMainMenu() {
      this.handleMainMenu({ value: false });
    },
    setActivePage(id) {
      this.activeMenuId = id;
    },
    getMenuList(parentId) {
      //console.log('this.$store.state.app.pages', this.$store.state.app.pages);
      return _.sortBy(
        this.$store.state.app.pages.filter(
          (x) => x.parentId == parentId && x.i2 == 1
        ),
        "ord",
        "asc"
      );
    },
    loadPage(task) {
      this.hideMainMenu();
      this.activeMenuId = task.id;
      //console.log(task.locTypeId);
      if (task.locTypeId == 39973) {
        //шууд агуулга
        //task.organizationTaskId
        this.handleDetailModal({ show: true, id: task.organizationTaskId });
      } else if (task.locTypeId == 39972) {
        this.$router.push({ name: "webList", params: { id: task.locTypeId1 } });
      } else if (task.locTypeId == 39971) {
        //engiin
        //alert(task.locTypeId1)
        if(task.locTypeId2!=null){
          this.$router.push({ name: task.taskEn, params: {id: task.locTypeId2} });
        }
        else{
          this.$router.push({ name: task.taskEn, params: {id: task.locTypeId1} });
        }
      }
    },
  },
};
</script>
